import moment from "moment";

import { removeHtmlTagsAndEntities, truncateText } from "../../../utils";

export function createSelectedColumnState(columns = []) {
  return columns.reduce((accumulator, column) => {
    accumulator[column.field] = true;
    return accumulator;
  }, {});
}

export function getVisibleWatchingColumns(columns = [], selectedColumn = {}) {
  return columns.filter((column) => selectedColumn[column.field]);
}

export function selectAllWatchingColumns(previousState = {}) {
  return Object.keys(previousState).reduce((accumulator, key) => {
    accumulator[key] = true;
    return accumulator;
  }, {});
}

export function getWatchingWorkflowStatus(workflowSteps = [], workflowStepId) {
  return (
    workflowSteps.find((step) => step?.workflow_step_id === workflowStepId)
      ?.status || ""
  );
}

export function getSortedWatchingWorkflowSteps(workflows) {
  return [...(workflows?.data?.data?.responseData || [])].sort(
    (a, b) => a?.step_sequence - b?.step_sequence
  );
}

export function filterWatchingProjects(
  projects = [],
  { searchText = "", filterUser, epicSearch = [] } = {}
) {
  let filteredProjects = [...projects];

  if (filterUser) {
    filteredProjects = filteredProjects.filter(
      (project) => project?.card?.assigned_to_user_id === Number(filterUser)
    );
  }

  if (epicSearch?.length) {
    filteredProjects = filteredProjects.filter((project) =>
      epicSearch.includes(project?.card?.epic_id)
    );
  }

  if (!searchText) {
    return filteredProjects;
  }

  return filteredProjects.filter((project) => {
    const normalizedSearch = searchText.toLowerCase();
    const boardCardKey = `${project?.key || ""}-${project?.card?.card_id || ""}`.toLowerCase();

    return (
      `${project?.card?.title || ""}`.toLowerCase().includes(normalizedSearch) ||
      `${project?.card?.assigned_to_user?.last_name || ""}`
        .toLowerCase()
        .includes(normalizedSearch) ||
      `${project?.card?.assigned_to_user?.first_name || ""}`
        .toLowerCase()
        .includes(normalizedSearch) ||
      `${project?.key || ""}`.toLowerCase().includes(normalizedSearch) ||
      `${project?.card?.card_id || ""}`.toLowerCase().includes(normalizedSearch) ||
      boardCardKey.includes(normalizedSearch) ||
      project?.labels?.some((label) =>
        `${label || ""}`.toLowerCase().includes(normalizedSearch)
      ) ||
      `${project?.card?.epic?.epic_name || ""}`
        .toLowerCase()
        .includes(normalizedSearch)
    );
  });
}

export function mapWatchingCardDetailItems(projects = []) {
  return projects.map((project) => ({
    ...project,
    ...project.card,
  }));
}

export function mapWatchingTableRows(projects = [], getCardStatus) {
  return projects.map((project) => ({
    id: project?.card?.card_id,
    col1: project,
    col2: project?.card?.title,
    col3: project?.workflow_step_status || "",
    col4: project?.card?.description
      ? truncateText(
          removeHtmlTagsAndEntities(project?.card?.description),
          85
        )
      : "",
    col5: project,
    col6: project?.labels?.join(", "),
    col7: project,
    col8: project?.card?.allocated_hours,
    col9: project?.total_hours_spent,
    col10: {
      hoursSpent: project?.total_hours_spent,
      allotedHours: project?.card?.allocated_hours,
    },
    col11: project?.card?.due_date
      ? moment(project?.card?.due_date).local().format("MMMM D,YYYY")
      : "",
    col12: project?.card?.date_created
      ? moment(project?.card?.date_created).local().format("MMMM D,YYYY")
      : "",
    col13: project,
  }));
}

export function getWatchingAvatarInitials(name = "") {
  return name
    .trim()
    .split(" ")
    .map((word) => word[0]?.toUpperCase())
    .join("");
}
